import { FlexCol } from 'components/Elements';
import styled from 'styled-components';
import { sizes } from '../../theme';

export const MainSection = styled(FlexCol)`
    justify-content: center;
    width: 100%;
    padding: 0 ${sizes.edgePadding};
    max-width: ${sizes.appMaxWidthWithoutPadding}px;
`;

export const MainSectionWithGaps = styled(MainSection)`
    margin: ${sizes.spacingLg} 0;
    gap: ${sizes.spacingLg};
`;

export const MainSectionWithSmallGaps = styled(MainSection)`
    margin-top: ${sizes.spacingSm};
    gap: ${sizes.spacingSm};
`;

export const MainSectionWithBottomPadding = styled(MainSection)`
    padding-bottom: ${sizes.spacingXl};
`;

export default MainSection;
